<div class="ruler-selector" (click)="$event.stopPropagation()">
  <div class="ruler-selector__field">
    <span class="ruler-selector__label">{{ 'ruler.icon' | translate }}</span>
    <div class="ruler-selector__options">
      <button *ngFor="let icon of rulerIcons" type="button" class="ruler-selector__option"
        [class.active]="rulerIcon === icon" (click)="changeRulerIcon.emit(icon)"
        [matTooltip]="'ruler.' + icon | translate" [attr.data-cy]="'ruler-icon-' + icon">
        <i [class]="rulerIconClasses[icon]"></i>
      </button>

      <button *ngIf="rulerIcon !== TRulerOption.NONE" type="button" class="ruler-selector__reset"
        (click)="resetRuler.emit()" data-cy="ruler-reset">
        {{ 'button.reset' | translate }}
      </button>
    </div>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'ruler.size' | translate }}</mat-label>
    <input matInput type="number" [value]="rulerSize" (change)="changeRulerSize.emit($event.target.value)" />
  </mat-form-field>
</div>
